import { render, staticRenderFns } from "./VoiceRecorder.vue?vue&type=template&id=d55c9d0a&scoped=true&"
import script from "./VoiceRecorder.vue?vue&type=script&lang=js&"
export * from "./VoiceRecorder.vue?vue&type=script&lang=js&"
import style0 from "./VoiceRecorder.vue?vue&type=style&index=0&id=d55c9d0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55c9d0a",
  null
  
)

export default component.exports